<template lang="html">
  <div class="container">
    <div class="divider_line">
      <span>基本信息</span>
    </div>
    <div class="one">
      <div class="one-left">
        <div><i class="iconfont">&#xe6b9;</i>{{detail.full_name | empty('暂无公司信息')}}</div>
        <div><i class="iconfont">&#xe63a;</i>{{detail.address | empty('暂无公司地址')}}</div>
        <div><i class="iconfont">&#xe64f;</i>{{detail.employee_id | deal('employee', 'employee', '暂无公司规模')}}</div>
        <div><i class="iconfont">&#xe632;</i>{{detail.setup_time | timeTrans('暂无注册时间')}}</div>
        <div><i class="iconfont">&#xe650;</i>
          <a :href="detail.main_page | page" target="_blank" v-if="detail.main_page">{{detail.main_page}}</a>
          <template v-else>暂无公司网站</template>
        </div>
        <div><i class="iconfont">&#xe635;</i>{{detail.tel | empty('暂无联系电话')}}</div>
        <div><i class="iconfont">&#xe638;</i>{{detail.email | empty('暂无公司邮箱')}}</div>
      </div>

      <div class="one-right" v-if="news.length!=0">
        <div class="news-module">
          <p class="open_xfly op">
            <img :src="$store.state.static_img_url+'pic/list/cyt3.png'" class="open_xfly_before"/>
              最新报道
            <img :src="$store.state.static_img_url+'pic/list/cyh3.png'" class="open_xfly_after"/>
          </p>
          <div class="check-more" @click="checkMore">
            <span>查看更多</span>
            <i class="iconfont right-icon">&#xe647;</i>
          </div>
          <div @click="go(item.uid)" class="news" v-for="(item, index) in news" v-if="index < 2" :key="index" onclick="_czc.push(['_trackEvent', '公司详情', '最新报道点击'])">
            <div class="news-title">
              {{item.title}}
            </div>
            <div class="news-time">
              <!-- {{item.summary ? item.summary : item.title}} -->
              {{item.create_time | timeTrans}}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="two">
      <Divider class="dash-divid" dashed v-if="ntag.length != 0 || detail.summary" />
      <div>
        <div class="summary">
          {{detail.summary}}
        </div>
      </div>
      <span>
        <h2 class="p2" v-if="ntag.length != 0">企业画像</h2>
        <div class="tag-row" v-if="ntag.length != 0" v-for="item in ntag" :key="item.id">
          <div class="two-left">{{item.id | deal('dynview_tag_type')}}</div>
          <div class="tag">
            <Tag color="default" v-for="(item1, index) in item.arr" :key="index">{{item1.tag_id | deal('dynview_tag')}}</Tag>
          </div>
        </div>
      </span>
    </div>
    <!-- <Divider /> -->
    <div>
      <div class="divider_line h2">
        <span>资本事件</span>
      </div>
      <div class="three">
        <div class="h3">当前融资</div>
        <div class="list_div">
          <Table :columns="invest_columns" :data="invest_list"></Table>
          <div class="page clear" v-if="invest_total > 10">
              <Page :total="invest_total" :page-size="10" show-total class="page_list" @on-change="handleInvestPage" show-elevator/>
          </div>
        </div>
        <div class="h3" style="margin-top: 24px">对外投资</div>
        <div class="list_div">
          <Table :columns="dwtz_columns" :data="dwtz_list"></Table>
          <div class="page clear" v-if="dwtz_total > 10">
              <Page :total="dwtz_total" :page-size="10" show-total class="page_list" @on-change="handleDwtzPage" show-elevator/>
          </div>
        </div>
      </div>
    </div>
    <Spin fix v-if="spinShow">
        <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
        <div>Loading</div>
    </Spin>
  </div>
</template>

<script>
import { entityDetail, topicList} from '../../../service'
import filter from 'js/filter'
export default {
  inject: ['reload','haddleBackModel'],
  data(){
    return {
      spinShow: true,
      params: {
        uid: this.$route.params.uid,
        type: 'base',
        entity_type: 0
      },
      params_event: {
        uid: this.$route.params.uid,
        type: 'event',
        entity_type: 0
      },
      params_news: {
        entity_uids: [this.$route.params.uid],
        page: 1
      },
      detail: '',
      ntag: [],
      dwtz: [],
      dwtz_list: [],
      dwtz_total: 0,
      dwtz_columns: [
        // { type: 'index', width: 40},
        { title: '日期',width: 150 , key: 'event_time', render: (h, params) => {return h('span', filter.timeTrans(params.row.event_time))} },
        { title: '轮次',width: 90 , key: 'round_id', render: (h, params) => {return h('span', params.row.type == '1' ? '并购' : filter.deal(params.row.round_id, 'round'))} },
        { title: '金额',width: 120 , key: 'amount', render: (h, params) => {return h('span', filter.amountPrecise(params.row.amount, params.row.unit_id, params.row.precise))} },
        { title: '领投',width: 160 , key: 'lead', render: (h, params) => {return h('span', filter.isno(params.row.lead))}},
        { title: '被投企业',width: 220 , key: 'ht_comp_name',render:(h, params) => {
          return h('a', {
            on: {click:() => {this.goEntityDetail(params.row.comp_uid, params.row.ht_comp_type)}},
          }, params.row.ht_comp_name)
        }},
        { title: '新闻来源',width: 120 , key: 'src_url', render: (h, params) =>{
          if (params.row.src_url) {
            return h('a', {
              class:{look_ico:true},
              attrs: { href: filter.page(params.row.src_url), target: '_blank'},
              on: {click:() => {_czc.push(['_trackEvent', '公司详情', '资本事件点击'])}},
            }, [
              h('i', {class: {iconfont: true}, domProps: {
                innerHTML: '&#xe62e;'
              }}),
              h('span','查看来源')
            ])
          } else {
            return h('span', '暂无')
          }
        }},
        { title: '操作', key: 'caozuo', render: (h, params) => {
          return h('a', {
              class: {caozuo: true},
              attrs: { href: 'javascript:void(0)'},
              on: {click:() => {this.haddleBackModel()}},
          }, '我要反馈')
        }}
      ],
      invest: [],
      invest_list: [],
      invest_total: 0,
      invest_columns: [
        // { type: 'index', width: 40},
        { title: '日期',width: 150, key: 'event_time', render: (h, params) => {return h('span', filter.timeTrans(params.row.event_time))} },
        { title: '轮次',width: 90, key: 'round_id', render: (h, params) => {return h('span', params.row.type == '1' ? '并购' : filter.deal(params.row.round_id, 'round'))} },
        { title: '金额',width: 120, key: 'amount', render: (h, params) => {return h('span', filter.amountPrecise(params.row.amount, params.row.unit_id, params.row.precise))} },
        { title: 'FA机构',width: 160, key: 'fa_name', render:(h, params) => {
          if(params.row.fa_entity_arr.length > 0){
            let fa = []
            params.row.fa_entity_arr.map((a,index) => {
              if(a.type != '2'){
                fa.push(h('a', {on: {click: () => {this.goEntityDetail(a.uid, a.type)}}}, a.short_name))
              }else{
                fa.push(h('span', a.short_name))
              }
              if(index < params.row.fa_entity_arr.length-1) fa.push(h('span', '、'))
            })
            return fa
          }else{
            return h('span','未透露')
          }
        }},
        { title: '投资方/并购方',width: 220, key: 'tz_entity',render: (h, params) =>{
          // tz_entity
          if(params.row.tz_entity.length > 0){
            let tzf = []
            params.row.tz_entity.map((a,index) => {
              if(a.entity_type != '2'){
                tzf.push(h('a', {on: {click: () => {this.goEntityDetail(a.entity_uid, a.entity_type)}}}, a.short_name))
              }else{
                tzf.push(h('span', a.short_name))
              }
              if(index < params.row.tz_entity.length-1) tzf.push(h('span', '、'))
            })
            return tzf
          }else{
            return h('span','未透露')
          }
        }},
        { title: '新闻来源',width: 120 , key: 'src_url', render: (h, params) =>{
          if (params.row.src_url) {
            return h('a', {
              class:{look_ico:true},
              attrs: { href: filter.page(params.row.src_url), target: '_blank'},
              on: {click:() => {_czc.push(['_trackEvent', '公司详情', '资本事件点击'])}},
          }, [
              h('i', {class: {iconfont: true}, domProps: {
                innerHTML: '&#xe62e;'
              }}),
              h('span','查看来源')
            ])
          } else {
            return h('span', '暂无')
          }
        }},
        { title: '操作', key: 'caozuo', render: (h, params) => {
          return h('a', {
              class: {caozuo: true},
              attrs: { href: 'javascript:void(0)'},
              on: {click:() => {this.haddleBackModel()}},
          }, '我要反馈')
        }}
      ],
      news: []
    }
  },
  computed: {
    uid() {
      return this.$route.params.uid
    },
    dynview_tag() {
      return this.$store.state.dynview_tag
    },
    dynview_tag_type() {
      return this.$store.state.dynview_tag_type
    }
  },
  methods: {
    async getDetail() {
      let res = await entityDetail(this.params, (error) => {
        this.$Message.error('请求错误！')
      })
      if(res.status == 'success') {
        this.$set(this.$data, 'detail', res.info[0])

        let his_arr = localStorage.history_entity ? JSON.parse(localStorage.history_entity) : []
        let index = his_arr.findIndex(a => a == this.detail.id)
        if (index > -1) his_arr.splice(index, 1)
        his_arr.unshift(this.detail.id)
        if (his_arr.length > 5) his_arr.pop()
        localStorage.history_entity = JSON.stringify(his_arr)


        let temp = [] // arr: , id: id
        for(let item of res.new_tags) {
          let fa = {}
          if (item.pid == null && item.pgid == null) {
            fa = this.dynview_tag.find(item1 => item1.id == item.tag_id)
          } else if(item.pid != null && item.pgid == null) {
            fa = this.dynview_tag.find(item1 => item1.id == item.pid)
          } else {
            fa = this.dynview_tag.find(item1 => item1.id == item.pgid)
          }
          if (fa) {
            let index = temp.findIndex((item1)=> item1.id == fa.type_id)
            if (index == -1) { // 可以排序
              temp.push({
                id: fa.type_id,
                arr: [item]
              })
            } else {
              temp[index].arr.push(item)
            }
          } else {
            console.log('fa is false')
          }
        }
        // console.log(temp)
        this.$set(this.$data, 'ntag', temp)
        this.$emit('getname', res.info[0], res.stock)
      } else {
        this.$Message.error(res.msg)
      }
      let res1 = await entityDetail(this.params_event, (error) => {
        this.$Message.error('请求错误！')
      })
      if(res1.status == 'success') {
        this.$set(this.$data, 'dwtz', res1.dwtz)
        this.$set(this.$data, 'dwtz_list', [...res1.dwtz].slice(0,10))
        this.dwtz_total = res1.dwtz.length
        // this.$set(this.$data, 'invest', res1.event)
        this.$set(this.$data, 'invest', res1.event)
        this.$set(this.$data, 'invest_list', [...res1.event].slice(0,10))
        this.invest_total = res1.event.length
      } else {
        this.$Message.error(res1.msg)
      }
      let res2 = await topicList(this.params_news, (error) => {
        this.$Message.error('请求错误！')
      })
      if(res2.status == 'success') {
        this.$set(this.$data, 'news', res2.res)
      } else {
        this.$Message.error(res2.msg)
      }
      this.spinShow = false
    },
    handleInvestPage(page) {
      this.$set(this.$data, 'invest_list', [...this.invest].slice(10*(page-1),10*page))
    },
    handleDwtzPage(page) {
      this.$set(this.$data, 'dwtz_list', [...this.dwtz].slice(10*(page-1),10*page))
    },
    go(uid) {
      const href = this.$store.state.index2_path + '/newsDetail/' + uid
      window.open(href, '_blank')
    },
    goEntityDetail(uid, type) {
      if (type == 2) {
        // this.$router.push({name: 'PeoDetail', params: {uid: uid}})
        const { href } = this.$router.resolve({
          name: "PeoDetail",
          params: {
            uid: uid
          }
        })
        window.open(href, '_blank')
      } else if(type == 1){
        // this.$router.push({name: 'OrgDetail', params: {uid: uid}})
        const { href } = this.$router.resolve({
          name: "OrgDetail",
          params: {
            uid: uid
          }
        })
        window.open(href, '_blank')
      } else if(type == 0){
        // this.$router.replace({name: 'CompanyDetail', params: {uid: uid}})
        const { href } = this.$router.resolve({
          name: "CompanyDetail",
          params: {
            uid: uid
          }
        })
        window.open(href, '_blank')
        // this.reload()
      } else if(type == 3){
        // this.$router.push({name: 'HospitalDetail', params: {uid: uid}})
        const { href } = this.$router.resolve({
          name: "HospitalDetail",
          params: {
            uid: uid
          }
        })
        window.open(href, '_blank')
      }
    },
    checkMore() {
      this.$emit('gonews', 'news')
    }
  },
  created() {
    this.getDetail()
  },
  watch: {
    uid(val) {
      this.spinShow = true
      this.getDetail()
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus'
$size = 14px
div()
  display: flex
  align-items: center
divAdd()
  margin-top: 20px
.h2
  margin-bottom: 38px
.p2
  margin-top: 24px
  margin-bottom: 14px
  font-weight: bold
  commonColor(#E9E9EB, #333333)
  font-size: 16px
.h3
  margin-bottom: 12px
  font-size: 14px
  commonColor(#BCBDC1, #666666)
.container
  padding: 40px 32px 32px 32px
.one
  display: flex
  margin-top: 38px
  padding-left: 18px
  &-left
    width: 60%
    font-size: $size
    a
      color: #188DED
      text-decoration: underline
      &:hover
        color: #69c0ff
    div
      commonColor(#E9E9EB, #333333)
      display: flex
    div+div
      divAdd()
    i
      margin-right: 12px
      font-size: $size
      color: #999
  &-right
    width: 40%
    // margin-right: 30px
.two
  margin-bottom: 36px
  padding-left: 18px
  // div
  //   display: flex
  .tag-row
    margin-top: 8px
    display: flex
  &-left
    flex: 0 0 80px
    min-width: 80px
    font-size: $size
    commonColor(#BCBDC1, #666666)
    vertical-align: top
    line-height: 22px
  .tag
    flex: auto
    .ivu-tag
      cursor: default
      margin: 0 8px 8px 0
      border: 0
      commonBgColor(#35383f, #f9f9f9)
      >>> .ivu-tag-text
        commonColor(#bcbdc1, #666666)
      &:hover
        opacity:1
.three
  padding-left: 18px
ellipsis()
  overflow: hidden
  white-space: nowrap
  text-overflow: ellipsis

// 新闻模块
.news-module
  padding: 24px
  commonBgColor(#2A2F42, #F9F9F9)
  position: relative
  .open_xfly
    position: absolute
    top: 12px
    left: 8px
    line-height: 24px
    color: #fff
    &.op
      background-color: #fcc036
    &_before
      position: absolute
      height: 30px
      width: 12px
      top: 0
      left: -12px
    &_after
      position: absolute
      height: 24px
      width: 16px
      top: 0
      right: -16px
.news
  // margin-top: 15px
  cursor: pointer
  max-width: 500px
  min-width: 250px
  &-title
    width: 100%
    font-size: 16px
    padding-left : 12px
    margin-bottom: 12px
    margin-top: 24px
    commonColor(#E9E9EB, #333333)
    border-left: 2px rgba(250, 122, 80, 1) solid
    ellipsis()
  &-time
    font-size: 14px
    commonColor(#797B83, #666666)
.news:hover
  .news-title
    color: rgba(250, 122, 80, 1)
.check-more
  text-align: right
  font-size: 12px
  color: rgba(250, 122, 80, 1)
  cursor: pointer
  &:hover
    color: #FC9C7C
.ivu-tag+.ivu-tag
  margin-left: 4px
a:hover
  color: rgba(250, 122, 80, 1)
.right-icon
  margin-right: 0 !important
  margin-left: 3px
  font-size: 12px
.ivu-divider-horizontal
  margin: 28px 0 24px 0
.summary
  line-height: 22px
  font-size: 14px
  commonColor(#E9E9EB, #333333)
.dash-divid
  border-top: 1px dashed
  commonBorderColor(#40444F, #E9E9E9)

.ivu-table-wrapper >>> .look_ico
  color: rgba(250, 122, 80, 1)
  .iconfont
    display: inline-table
    vertical-align: top
    font-size: 14px
    margin-right: 4px
  &:hover
    color: #FC9C7C
</style>
